import Seo from "../components/Seo";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, resolveImg } from "../lib/api";
import { Newspaper, ArrowRight } from "lucide-react";

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then(({ data }) => setPosts(data)); document.title = "Блог | PenichArt"; }, []);
  return (
    <div data-testid="blog-list">
      <Seo title="Блог" path="/blog" description="Статии за изкуство, съвети за подбор на картини за дома и вдъхновение от галерия PenichArt." />
      <div className="bg-navy text-ivory">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 text-center">
          <h1 className="font-serif text-4xl md:text-5xl text-white">Блог</h1>
          <p className="text-ivory/70 mt-3">Истории, вдъхновение и съвети за изкуството в дома.</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
        {posts.length === 0 ? (
          <div className="text-center py-16 text-charcoal/50 flex flex-col items-center gap-3"><Newspaper size={40} className="text-gold" /> Скоро очаквайте първите статии.</div>
        ) : (
          <div className="grid md:grid-cols-3 gap-7">
            {posts.map((p) => (
              <Link key={p.id} to={`/blog/${p.slug}`} className="group bg-white border border-stone overflow-hidden" data-testid={`blog-${p.slug}`}>
                <div className="aspect-[16/10] bg-stone overflow-hidden">{p.cover_image && <img src={resolveImg(p.cover_image)} alt={p.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />}</div>
                <div className="p-5">
                  <h2 className="font-serif text-xl text-navy group-hover:text-gold transition-colors">{p.title}</h2>
                  <p className="text-sm text-charcoal/60 mt-2 line-clamp-3">{p.excerpt}</p>
                  <span className="inline-flex items-center gap-1.5 text-gold text-sm mt-3">Прочети <ArrowRight size={14} /></span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
